// data-clipboard-target に指定した文字列をクリップボードにコピーする共通フック。
// 詳細: .spec/DESIGN-tier4-b-tier2-polish.md §4-2
(function () {
  'use strict';
  if (typeof document === 'undefined') return;
  if (window._clipboardInit) return;
  window._clipboardInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-clipboard-target]');
    if (!btn) return;
    var text = btn.dataset.clipboardTarget;
    if (!navigator.clipboard || !text) return;
    navigator.clipboard.writeText(text).then(function () {
      var old = btn.textContent;
      btn.textContent = 'コピーしました';
      setTimeout(function () { btn.textContent = old; }, 1500);
    }).catch(function () { /* 失敗時は何もしない */ });
  });
})();
